module.exports = __webpack_public_path__ + "img/order.1d42312a.png";